"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
var dp_acma_dawn_sdk_1 = require("@greatmindsorg/dp-acma-dawn-sdk");
var base_service_1 = require("./base.service");
var serializers_1 = require("./serializers");
var api_constants_1 = require("../constants/api.constants");
var constants_1 = require("../constants");
var dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
var UserService = /** @class */ (function (_super) {
    __extends(UserService, _super);
    function UserService(options, profileClient, studentClient, userSerializer, userSerializerHTTPData, districtStaffClient, disrtictStaffSerializer, client) {
        var _this = _super.call(this, options) || this;
        _this.profileClient = profileClient;
        _this.studentClient = studentClient;
        _this.userSerializer = userSerializer;
        _this.userSerializerHTTPData = userSerializerHTTPData;
        _this.disrtictStaffSerializer = disrtictStaffSerializer;
        _this.districtStaffClient = districtStaffClient;
        _this.client = client;
        return _this;
    }
    UserService.newInstance = function (options) {
        return new UserService(options, dp_acma_dawn_sdk_1.ProfileClient.newInstance({
            baseURL: api_constants_1.ROSTERING_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), dp_acma_dawn_sdk_1.StudentClient.newInstance({
            baseURL: api_constants_1.ROSTERING_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), new serializers_1.UserSerializer(), new serializers_1.UserSerializerHTTPData(), dp_acma_dawn_sdk_1.DistrictStaffClient.newInstance({
            baseURL: api_constants_1.ROSTERING_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized), new serializers_1.DistrictStaffSerializer(), dp_http_client_lib_1.RetryableHttpClient.newInstance({
            baseURL: api_constants_1.ROSTERING_API_BASE_URL,
        }, options.retryOptionsOnNonAuthorized));
    };
    UserService.prototype.findOne = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO there is no find one for teachers at the rostering api, using the find current for now.
                return [2 /*return*/, this.findCurrent()];
            });
        });
    };
    UserService.prototype.findCurrent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dto;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.profileClient.findCurrent(this.getRosterDefaultHeaders())];
                    case 1:
                        dto = _a.sent();
                        return [2 /*return*/, this.userSerializer.serialize(dto)];
                }
            });
        });
    };
    UserService.prototype.findCurrentWithHeaders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var httpResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.get('/roster/profile', this.getRosterDefaultHeaders())];
                    case 1:
                        httpResponse = _a.sent();
                        return [2 /*return*/, {
                                user: this.userSerializer.serialize(this.userSerializerHTTPData.serializeOne(httpResponse.body)),
                                headers: httpResponse.headers,
                            }];
                }
            });
        });
    };
    /**
     * Finds students by ids
     * @param {string[]}                studentIds             - student identifiers
     * @param {boolean}                 archived               - indicates if it should return archived students
     * @param {boolean}                 includeClasses         - indicates if it should return details of classes of students
     * @returns {Promise<User>}         students matching the id
     */
    UserService.prototype.findByIds = function (userIds_1) {
        return __awaiter(this, arguments, void 0, function (userIds, archived, isDeleted, includeClasses) {
            var data;
            var _this = this;
            if (archived === void 0) { archived = false; }
            if (isDeleted === void 0) { isDeleted = false; }
            if (includeClasses === void 0) { includeClasses = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.studentClient.findByIds(userIds, this.getRosterDefaultHeaders(), archived, isDeleted, includeClasses)];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.map(function (user) {
                                user.roles = [constants_1.UserRole.Student]; // ACMA removed the roles from this repsonse
                                return _this.userSerializer.serialize(user);
                            })];
                }
            });
        });
    };
    UserService.prototype.findByClass = function (classId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.studentClient.findByClass(classId, this.getRosterDefaultHeaders())];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data.map(function (user) {
                                user.roles = [constants_1.UserRole.Student]; // ACMA removed the roles from this repsonse
                                return _this.userSerializer.serialize(user);
                            })];
                }
            });
        });
    };
    /**
     * Finds students by ids
     * @param {string[]}  schoolIds - school id's under selected admin user
     * @param {string}    districtId - district id for selected user
     * @param {string[]}  role
     */
    UserService.prototype.findDistrictStaff = function (filters_1) {
        return __awaiter(this, arguments, void 0, function (filters, skip, limit) {
            var _a, data, totalRecords, staffList;
            var _this = this;
            if (skip === void 0) { skip = 0; }
            if (limit === void 0) { limit = 100; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.districtStaffClient.findDistrictStaff(this.getRosterDefaultHeaders(), filters, skip, limit)];
                    case 1:
                        _a = _b.sent(), data = _a.data, totalRecords = _a.totalRecords;
                        staffList = data.map(function (staff) {
                            return _this.disrtictStaffSerializer.serialize(staff);
                        });
                        return [2 /*return*/, { totalRecords: totalRecords, staffList: staffList }];
                }
            });
        });
    };
    return UserService;
}(base_service_1.BaseService));
exports.UserService = UserService;
